import { Titles } from "../../layouts/Titles";
import React, { FormEvent, useEffect, useRef } from "react";
import { Button, Row, Space, Table } from "antd";
import controller from './controller'
import { FunctionComponentTypeForm } from "./FunctionComponentTypeForm";
import { observer } from "mobx-react-lite";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";

interface FunctionComponentInterface {
  options: {
    title: string
    buttons?: any
    items: FunctionComponentItemInterface[]
    model?: any
    formAction?: any
  },
  form?: boolean
  valueKey?: string | null
}

interface FunctionComponentItemInterface {
  type: string
  columns?: any[]
  requestData?: any
  fields?: any[]
  actions?: any
}

export const FunctionComponent = observer(({ options, form = false }: FunctionComponentInterface) => {

  const valueKeyRef = useRef(controller.randKey())
  const value_Key = valueKeyRef.current

  if (options.model && !controller.models[value_Key]) {
    controller.models[value_Key] = options.model
  }

  if (options.formAction) {
    controller.formAction = options.formAction
  }

  return (
      <Row>
        {form
            ? (
                <form onSubmit={(e: FormEvent) => controller.sendForm(e, value_Key)}>
                  <FunctionComponentMain options={options} form={form} valueKey={value_Key} />
                </form>
            )
            : <FunctionComponentMain options={options} form={form} valueKey={value_Key} />
        }
      </Row>
  )
})

const FunctionComponentMain = ({ options, valueKey }: FunctionComponentInterface) => {
  return (
      <>
        <Titles
            title={options.title}
            buttons={options.buttons}
        />

        {options.items.map((el: any, index: number) => {
          if (el.type === 'table') {
            return (
                <TypeTable
                    key={`table_${index}`}
                    columns={el.columns}
                    actions={el.actions}
                    requestData={el.requestData}
                    valueKey={valueKey}
                />
            )
          }

          if (el.type === 'form') {
            return (
                <TypeForm
                    key={`form_${index}`}
                    columns={el.columns}
                    requestData={el.requestData}
                    fields={el.fields}
                    valueKey={valueKey}
                />
            )
          }

          return null
        })}
      </>
  )
}

const TypeTable = observer(({ columns, actions, requestData, valueKey }: any) => {

  useEffect(() => {
    if (requestData) controller.request(requestData, valueKey)

    if (actions?.edit || actions?.delete) {
      columns.push({
        key: 'action',
        render: (text: any, record: any) => (
            <Space size="middle">
              {actions.edit && (
                  <Button
                      type="dashed"
                      shape="circle"
                      icon={<EditOutlined />}
                      href={actions.edit.isId ? `${actions.edit.redirect}/${record.id}` : `${actions.edit.redirect}`}
                  />
              )}

              {actions.delete && (
                  <Button
                      type="dashed"
                      shape="circle"
                      danger
                      icon={<DeleteOutlined />}
                      onClick={() => controller.delete(record.id, actions.delete)}
                  />
              )}
            </Space>
        )
      })
    }
  }, [])

  return (
      <Table
          columns={columns}
          dataSource={controller.lists[valueKey] ?? []}
      />
  )
})

const TypeForm = observer(({ requestData, fields, valueKey }: any) => {

  useEffect(() => {
    if (requestData) controller.request(requestData, valueKey)
  }, [])

  return (
      <Row gutter={[20, 20]} justify="space-between" align="bottom">
        {fields.map((field: any, index: number) => (
            <FunctionComponentTypeForm
                field={field}
                key={`type_form_${index}`}
                valueKey={valueKey}
            />
        ))}
      </Row>
  )
})